exports.STAR_STATUS_CODE = {
  PROPOSAL: '2',
  POLICY: '5',
};
